function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { format } from '@bydesign-ui/utils';
export function detect(rule, value) {
  var fn = rule.fn,
      errorTip = rule.errorTip;

  if (fn == null) {
    return Promise.resolve();
  }

  try {
    var result = fn(value, this);

    if (result != null && _typeof(result) === 'object' && typeof result.then === 'function') {
      return result.catch(function (e) {
        var str = e == null || typeof e === 'string' ? e || '' : e.message;

        if (str) {
          return Promise.reject(format(str, rule));
        }

        return Promise.reject(typeof errorTip === 'function' ? errorTip(rule) : typeof errorTip === 'string' ? format(errorTip, rule) : 'error');
      });
    }

    return Promise.resolve();
  } catch (e) {
    return Promise.reject(e.message);
  }
}